export default __webpack_public_path__ + "static/media/influence.ef01b942.svg";